export const CHANEL_NOTIFIKASI = (session) => "/bkdp/session=" + session;
